// extracted by mini-css-extract-plugin
export default {"screen":"classes_screen__8cxyb"};